import PropTypes from 'prop-types';
import React from 'react';

import IconChevronLeft from '../Icons/IconChevronLeft';

const BackActionButton = ({ action }) => (
  <nav className="row-spacer">
    <button type="button" title="back action button" className="nav-button flex" onClick={action}>
      <IconChevronLeft classNames="size-1" />
    </button>
  </nav>
);

BackActionButton.propTypes = {
  action: PropTypes.func.isRequired,
};

export default BackActionButton;
